class CustomerAddresses extends HTMLElement {
  constructor() {
    super();
    this.addListeners();
  }

  addListeners() {
    this.querySelector('.js-add-address').addEventListener('click', CustomerAddresses.handleAddBtnClick);

    this.querySelectorAll('.js-edit-address').forEach((btn) => {
      btn.addEventListener('click', CustomerAddresses.handleEditBtnClick);
    });

    this.querySelectorAll('.js-delete-address').forEach((btn) => {
      btn.addEventListener('click', CustomerAddresses.handleDeleteBtnClick);
    });

    this.querySelectorAll('.js-cancel').forEach((btn) => {
      btn.addEventListener('click', CustomerAddresses.handleCancelBtnClick);
    });

    // Add listeners for close buttons
    this.querySelectorAll('.js-close-drawer').forEach((btn) => {
      btn.addEventListener('click', CustomerAddresses.handleCloseBtnClick);
    });
  }

  /**
   * Opens a drawer with overlay.
   * @param {HTMLElement} drawer - Drawer element to open.
   */
  static openDrawer(drawer) {
    if (!drawer) return;

    const overlay = document.querySelector('.js-overlay');
    if (overlay) {
      overlay.classList.add('is-visible');
    }

    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
  }

  /**
   * Checks if any drawer is currently open.
   * @returns {boolean} True if any drawer is open.
   */
  static hasOpenDrawer() {
    // Check side-drawer elements
    const sideDrawers = document.querySelectorAll('side-drawer[open]');
    if (sideDrawers.length > 0) return true;

    // Check side-drawer-new elements
    const sideDrawerNews = document.querySelectorAll('side-drawer-new[open]');
    if (sideDrawerNews.length > 0) return true;

    return false;
  }

  /**
   * Closes a drawer and removes overlay only if no other drawer is open.
   * @param {HTMLElement} drawer - Drawer element to close.
   */
  static closeDrawer(drawer) {
    if (!drawer) return;

    drawer.removeAttribute('open');
    drawer.setAttribute('aria-hidden', 'true');

    // Only remove overlay if no other drawer is open
    if (!CustomerAddresses.hasOpenDrawer()) {
      const overlay = document.querySelector('.js-overlay');
      if (overlay) {
        overlay.classList.remove('is-visible');
      }
    }
  }

  /**
   * Handles 'click' events on the 'add new address' button.
   */
  static handleAddBtnClick() {
    const drawer = document.getElementById('add-address-drawer');
    CustomerAddresses.openDrawer(drawer);
  }

  /**
   * Handles 'click' events on 'edit address' buttons.
   * @param {object} evt - Event object.
   */
  static handleEditBtnClick(evt) {
    const drawer = document.getElementById(`edit-${evt.target.dataset.addressId}-drawer`);
    CustomerAddresses.openDrawer(drawer);
  }

  /**
   * Handles 'click' events on 'delete address' buttons.
   * @param {object} evt - Event object.
   */
  static handleDeleteBtnClick(evt) {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm(evt.target.getAttribute('data-confirm-message'))) {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = evt.target.dataset.target;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = '_method';
      input.value = 'delete';
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }
  }

  /**
   * Handles 'click' events on 'cancel' buttons.
   * @param {object} evt - Event object.
   */
  static handleCancelBtnClick(evt) {
    const drawer = evt.target.closest('side-drawer-new') || evt.target.closest('side-drawer');
    CustomerAddresses.closeDrawer(drawer);
  }

  /**
   * Handles 'click' events on 'close' buttons.
   * @param {object} evt - Event object.
   */
  static handleCloseBtnClick(evt) {
    const drawer = evt.target.closest('side-drawer-new') || evt.target.closest('side-drawer');
    CustomerAddresses.closeDrawer(drawer);
  }
}

customElements.define('customer-addresses', CustomerAddresses);
